"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceNotSetWithUndefined = void 0;
function replaceNotSetWithUndefined(property) {
    return property === 'NOT_SET' ? undefined : property;
}
exports.replaceNotSetWithUndefined = replaceNotSetWithUndefined;
